import { Context } from '@nuxt/types'
import { seoPropertiesClient } from '~/server/api/clients/seo-properties'
import { APIResponse } from '~/types/api/api-response'
import { SEO_INTERAL_PATH } from '~/types/api/seo-properties'
import { SeoProperties } from '~/types/model/seo'

export const SeoPropertiesAPI = ({ $axios }: Context) => {
  const retrieveSEOProperties = (pageKey: string) => {
    return process.server
      ? seoPropertiesClient.retrieveSEOProperties(pageKey)
      : $axios.get<APIResponse<SeoProperties>>(SEO_INTERAL_PATH.replace(':id', `${pageKey}`))
  }

  return {
    retrieveSEOProperties,
  }
}
